"use client";

export function ChartProductCompetencySkeleton() {
  return (
    <div className="space-y-6">
      {/* Chart Area Skeleton */}
      <div className="h-80 w-full pr-6 px-6">
        <div className="h-full w-full bg-gray-100 rounded-lg animate-pulse relative overflow-hidden">
          {/* Grid lines simulation */}
          <div className="absolute inset-0 flex flex-col justify-between p-4">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="h-px bg-gray-200" />
            ))}
          </div>

          {/* Area chart simulation */}
          <div className="absolute bottom-0 left-0 right-0 h-2/3 bg-gradient-to-t from-gray-300/50 to-transparent rounded-b-lg" />
        </div>

        {/* X-axis labels skeleton */}
        <div className="flex justify-between mt-2 px-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-3 w-8 bg-gray-200 rounded animate-pulse"
            />
          ))}
        </div>
      </div>

      {/* Legend Skeleton */}
      <div className="flex flex-wrap justify-center gap-6 mt-6 border-t border-secondary-500 pt-6 px-6">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-gray-300 animate-pulse" />
            <div className="h-4 w-24 bg-gray-200 rounded animate-pulse" />
            <div className="h-3 w-16 bg-gray-200 rounded animate-pulse" />
          </div>
        ))}
      </div>
    </div>
  );
}
